import type { ItemOffer } from "@anaconda/core/bid/types"
import { LISTING_SOURCE_NAME } from "@anaconda/core/nft/listing-source"
import { Trans } from "@lingui/react/macro"
import { Badge } from "@rarible_int/anaconda_ui_components"

/**
 * A collection offer shown on an item page is acceptable on this NFT but was
 * not made for it specifically — say so, or the two read as the same thing.
 */
export function OfferKindBadge({ offer }: { offer: ItemOffer }) {
  if (offer.kind === "COLLECTION") {
    return (
      <Badge variant="secondary" className="whitespace-nowrap">
        <Trans>Collection</Trans>
      </Badge>
    )
  }

  return (
    <Badge variant="outline" className="whitespace-nowrap">
      <Trans>Item</Trans>
    </Badge>
  )
}

export function OfferSourceBadge({ offer }: { offer: ItemOffer }) {
  if (!offer.source) return null

  return (
    <Badge variant="secondary" className="whitespace-nowrap">
      {LISTING_SOURCE_NAME[offer.source]}
    </Badge>
  )
}
